//
// DataDefinitionFilterInfo.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../../models/BIRDModel";
import "./DataDefinitionFilterType";
import "../../models/dataDefinition/common/FilterItemBase";
import "@sas-dvr/ltjs-commons/rules/expressions/Expression";
import "./CategoryValueInfo";
import "./MeasureValueInfo";
import "../../models/dataDefinition/DataItem";

var DataDefinitionFilterInfo = createModule("BIRD::DataDefinitionFilterInfo", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        measureValue: 1,
        filterItem: 1,
        includeMissing: 2,
        selectAll: 2,
        keepMeasureValue: 2,
        expression: 1,
        isOnlyAggregated: 2,
        discreteMeasure: 2,
        aggregated: 2,
        filterType: 4,
        isCommonFilter: 2,
        categoryValues: [1],
    },
    ,
    {
        dataItems: [1],
    },
    {
        isReadOnly: [2],
        getName: [7],
        getLabel: [7],
        clone: [1],
        hasCASResource: [2],
    },
    ,
    ,
]);
export default DataDefinitionFilterInfo;
